import { Heading } from '@drycut/ui-components';
import { type PropsWithChildren } from 'react';

export default function EmptyState({ children }: PropsWithChildren): React.ReactElement {
  return (
    <Heading variant="h4" className="font-thin font-aribau text-zinc-400 p-6">
      {children}
    </Heading>
  );
}
